/* Tennis Lab FX: "Notify me when available" (draft theme only).
   The form posts to Shopify's own contact form, into a hidden frame so the page does not reload, and the confirmation
   appears in place. The form shows only while the selected size is sold out, and the size and link are filled in
   automatically. If the visitor is sent to a captcha, the form finishes as a normal page submit and the confirmation
   shows when Shopify returns to the page. */
(function () {
  'use strict';
  var KEY = 'tlfx-notify';

  function init() {
    var box = document.querySelector('[data-tlfx-notify]');
    if (!box || box._tlfx) return;
    box._tlfx = true;
    var form = box.querySelector('form'), btn = box.querySelector('.tlfx-notify__btn'), msg = box.querySelector('[data-tlfx-msg]');
    var done = box.querySelector('[data-tlfx-done]'), email = box.querySelector('input[type="email"]');
    if (!form || !btn) return;
    var data = [];
    try { data = JSON.parse(box.querySelector('[data-tlfx-variants]').textContent); } catch (e) { /* no variant data */ }
    var info = box.closest('.product__info-container') || document.body;
    var title = box.getAttribute('data-title') || '', base = box.getAttribute('data-url') || '';
    var sentFor = null, keepOpen = false;

    function store(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) { /* private mode */ } }
    function load() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
    function clear() { try { sessionStorage.removeItem(KEY); } catch (e) { /* private mode */ } }

    function currentId() {
      var el = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (el && el.value) return +el.value;
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      return m ? +m[1] : null;
    }
    function currentVariant() {
      var id = currentId(), v = null;
      data.forEach(function (x) { if (x.id === id) v = x; });
      return v;
    }
    function say(text) { msg.textContent = text; msg.hidden = !text; }

    function update() {
      var v = currentVariant();
      var out = v ? !v.available : (data.length > 0 && data.every(function (x) { return !x.available; }));
      // A confirmation belongs to the size the visitor is looking at; picking another size starts fresh.
      if (sentFor !== null && sentFor !== (v ? v.id : 0)) { sentFor = null; done.hidden = true; form.hidden = false; clear(); }
      box.hidden = !(out || sentFor !== null || keepOpen);
      info.classList.toggle('tlfx-out', out);
      var size = v && v.title && v.title !== 'Default Title' ? v.title : '';
      form.querySelector('[data-tlfx-size]').value = size;
      form.querySelector('[data-tlfx-link]').value = window.location.origin + base + (v ? '?variant=' + v.id : '');
      form.querySelector('[data-tlfx-body]').value = 'Please email me when ' + title + (size ? ' in size ' + size : '') + ' is back in stock.';
      box.querySelector('[data-tlfx-lead]').textContent = 'We will email you once when ' + (size ? 'size ' + size : 'it') + ' is available again.';
    }

    function showDone(text) {
      box.querySelector('[data-tlfx-done-text]').textContent = text;
      form.hidden = true; done.hidden = false; box.hidden = false;
    }

    // The request is sent into a hidden frame so the page does not reload and the confirmation appears in place.
    // The frame is same-origin, so its result can be inspected; if it cannot be read, the send is treated as done
    // (the request has already reached Shopify) rather than showing a false error.
    var frame = document.createElement('iframe');
    frame.name = 'tlfx-notify-frame';
    frame.title = 'Notify me request';
    frame.hidden = true;
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    box.appendChild(frame);
    form.target = frame.name;
    var pending = false, timer = null, lockTimer = null;

    function reset() { clearTimeout(lockTimer); btn.disabled = false; btn.removeAttribute('aria-busy'); }
    function succeed(address) {
      var v = currentVariant();
      sentFor = v ? v.id : 0;
      var size = form.querySelector('[data-tlfx-size]').value;
      showDone('Thanks. We will email ' + address + ' when ' + (size ? 'size ' + size : 'this') + ' is back in stock.');
      reset(); clear();
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (done.animate && !calm) done.animate([{ opacity: 0, transform: 'translateY(.8rem)' }, { opacity: 1, transform: 'none' }], { duration: 400, easing: 'cubic-bezier(.22,1,.36,1)' });
      if (box.scrollIntoView) box.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'nearest' });
    }
    function problem() { reset(); say('We could not send that. Please try again, or call (646) 669-8444.'); }

    form.addEventListener('submit', function () {
      store({ email: email.value, size: form.querySelector('[data-tlfx-size]').value });
      say('');
      pending = true;
      btn.setAttribute('aria-busy', 'true');
      lockTimer = setTimeout(function () { btn.disabled = true; }, 0);   // after the browser has started the submit
      clearTimeout(timer);
      timer = setTimeout(function () { if (pending) { pending = false; problem(); } }, 20000);
    });

    frame.addEventListener('load', function () {
      if (!pending) return;
      pending = false; clearTimeout(timer);
      var address = email.value, href = '', html = '';
      try {
        href = frame.contentWindow.location.href || '';
        html = frame.contentDocument.documentElement.outerHTML || '';
      } catch (e) { succeed(address); return; }          // not readable: the request was sent
      if (/\/challenge/.test(href)) { form.target = ''; form.submit(); return; }   // captcha: finish in the normal page
      if (html.indexOf('data-tlfx-error') > -1) { problem(); return; }
      succeed(address);
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, fieldset.product-form__input')) {
        keepOpen = false; say('');
        setTimeout(update, 250); setTimeout(update, 900);
      }
    });
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { update(); });
      }
    } catch (e) { /* the change listener above covers it */ }

    // Back from Shopify: the page was rendered with the result of the submission.
    if (box.querySelector('[data-tlfx-posted]')) {
      var saved = load();
      var v0 = currentVariant();
      sentFor = v0 ? v0.id : 0;
      showDone('Thanks. We will email ' + (saved && saved.email ? saved.email : 'you') + ' when ' +
        (saved && saved.size ? 'size ' + saved.size : 'this') + ' is back in stock.');
      clear();
    } else if (box.querySelector('[data-tlfx-error]')) {
      keepOpen = true;
      say('We could not send that. Please try again, or call (646) 669-8444.');
    }
    update();
    setTimeout(update, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
